import { Button } from "@material-ui/core";
import PlayIcon from "@material-ui/icons/PlayArrow";
import React from "react";
import IconDuration from "../../resources/icons/icon_duration.png";
import IconFrequency from "../../resources/icons/icon_frequency.png";
import IconReps from "../../resources/icons/icon_reps.png";
import IconSets from "../../resources/icons/icon_sets.png";
import IconWeight from "../../resources/icons/icon_weight.png";
import IconRest from "../../resources/icons/icon_rest.png";
import IconHold from "../../resources/icons/icon_hold.png";
import IconTempo from "../../resources/icons/icon_tempo.png";
import colors, { colorsV2 } from "../../styles/colors";
import { getCategoryThumbnailUrl } from "../utils/CategoryUtils";

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    borderRadius: 8,

    minHeight: 100,
    padding: 0,
    margin: "10px 0px 10px 0px",
    borderStyle: "solid",
    borderWidth: 2,
    borderColor: colors.lightGrey,
    boxShadow: "5px 4px 9px 0px rgba(159,159,159,0.75)",
  },
  group: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: colorsV2.primary,
    borderRadius: 7,
    color: colorsV2.white,
    backgroundColor: colorsV2.primary,
    padding: 5,
  },
  instructionContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: 10,
  },
  thumbnail: {
    height: 190,
    width: 130,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  title: {
    fontFamily: "Poppins-SemiBold",
    fontSize: 16,
    color: colorsV2.codGray,
    padding: 0,
    margin: "0px 10px 10px 0px",
    wordBreak: "break-word",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    lineHeight: "16px",
    maxHeight: "32px",
  },
  description: {
    fontFamily: "Poppins-Regular",
    fontSize: 14,
    color: colorsV2.silverChalice,
    padding: 0,
    margin: "0px 10px 10px 0px",
    wordBreak: "break-word",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    lineHeight: "16px",
    maxHeight: "32px",
  },
  attributesContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    marginTop: 10,
  },
  attributeContainer: {
    width: 100,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    padding: 0,
    margin: 0,
  },
  attributeIcon: {
    height: 25,
    width: 25,
    padding: 0,
    margin: 0,
  },
  attributeName: {
    fontSize: 12,
    padding: 0,
    margin: 0,
    color: "#476F83",
  },
  attributeValue: {
    fontSize: 12,
    padding: 0,
    margin: 0,
  },
  playBtnContainer: {
    display: "flex",
    flexDirection: "row-reverse",
  },
  viewBtnStyle: {
    backgroundColor: colorsV2.lightningYellow,
    color: colorsV2.white,
    width: 100,
    borderRadius: 14,
    fontFamily: "Poppins-SemiBold",
  },
};

export default (props) => {
  const thumbnailUrl = getCategoryThumbnailUrl(props);
  return (
    <div>
      <div style={styles.container}>
        {thumbnailUrl != null && (
          <div
            style={{
              ...styles.thumbnail,
              backgroundImage: `url(${thumbnailUrl})`,
            }}
          ></div>
        )}
        <div style={styles.instructionContainer}>
          {props.groupName && (
            <p>
              <span style={styles.group}>{props.groupName}</span>
            </p>
          )}
          <p style={styles.title}>
            {props.archived && "*Archived*  "}

            {props.categoryName}
          </p>
          <p style={styles.description}>{props.categoryDesc}</p>
          <div style={styles.attributesContainer}>
            {props.numRepetitions && (
              <div style={styles.attributeContainer}>
                <img src={IconReps} style={styles.attributeIcon} />
                <p style={styles.attributeName}>Reps</p>
                <p style={styles.attributeValue}>{props.numRepetitions}</p>
              </div>
            )}
            {props.numSets && (
              <div style={styles.attributeContainer}>
                <img src={IconSets} style={styles.attributeIcon} />
                <p style={styles.attributeName}>Sets</p>
                <p style={styles.attributeValue}>{props.numSets}</p>
              </div>
            )}
            {props.duration && (
              <div style={styles.attributeContainer}>
                <img src={IconDuration} style={styles.attributeIcon} />
                <p style={styles.attributeName}>Duration</p>
                <p style={styles.attributeValue}>{props.duration}</p>
              </div>
            )}
            {props.frequency && (
              <div style={styles.attributeContainer}>
                <img src={IconFrequency} style={styles.attributeIcon} />
                <p style={styles.attributeName}>Frequency</p>
                <p style={styles.attributeValue}>{props.frequency}</p>
              </div>
            )}

            {props.rest && (
              <div style={styles.attributeContainer}>
                <img src={IconRest} style={styles.attributeIcon} />
                <p style={styles.attributeName}>Rest</p>
                <p style={styles.attributeValue}>{props.rest}</p>
              </div>
            )}
            {props.hold && (
              <div style={styles.attributeContainer}>
                <img src={IconHold} style={styles.attributeIcon} />
                <p style={styles.attributeName}>Hold</p>
                <p style={styles.attributeValue}>{props.hold}</p>
              </div>
            )}
            {props.tempo && (
              <div style={styles.attributeContainer}>
                <img src={IconTempo} style={styles.attributeIcon} />
                <p style={styles.attributeName}>Tempo</p>
                <p style={styles.attributeValue}>{props.tempo}</p>
              </div>
            )}
            {props.weight && (
              <div style={styles.attributeContainer}>
                <img src={IconWeight} style={styles.attributeIcon} />
                <p style={styles.attributeName}>Weight</p>
                <p style={styles.attributeValue}>{props.weight}</p>
              </div>
            )}
          </div>
          <div style={styles.playBtnContainer}>
            <Button
              variant="contained"
              size="small"
              startIcon={<PlayIcon />}
              style={styles.viewBtnStyle}
              onClick={() => props.onClick()}
            >
              View
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/InstructionListItem.js